import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">
          Copyright © {currentYear} Meyle Ingeniería y Servicios · Todos los derechos reservados
        </p>
        <Link to="/terminos" className="footer-link">
          Términos y condiciones
        </Link>
      </div>
    </footer>
  );
};

export default Footer;